/* Just Brilliant: retryable catalogue pagination; advance only after rendering. */
if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.button = this.querySelector('.load-more');
      if (!this.button && !this.classList.contains('pagination-type--paginated')) {
        this.done = true;
        this.hidden = true;
        return;
      }
      this.grid = document.querySelector('[data-id="' + CSS.escape(this.dataset.section) + '"]');
      this.pageSize = Number(this.dataset.pageSize) || 12;
      this.page = this.page || (Number(new URL(location.href).searchParams.get('page')) || 1) + 1;
      this.animationsEnabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.button?.addEventListener('click', event => {
        if (this.button.matches('a') && (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
        event.preventDefault();
        this.loadProducts();
      }, { signal: this.lifecycle.signal });
      if (this.classList.contains('pagination-type--infinite') && typeof IntersectionObserver !== 'undefined') {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadProducts();
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.lifecycle?.abort(); this.lifecycle = null;
      this.controller?.abort();
      this.observer?.disconnect();
    }
    async loadProducts() {
      if (this.controller || this.done || !this.grid || !this.isConnected) return;
      const controller = this.controller = new AbortController();
      const url = new URL(this.button?.getAttribute('href') || location.href, location.href);
      if (!this.button?.getAttribute('href')) url.searchParams.set('page', this.page);
      this.setAttribute('loading', 'true');
      this.setAttribute('aria-busy', 'true');
      if (this.button) { this.button.disabled = true; this.button.setAttribute('aria-disabled', 'true'); }
      this.querySelector('[data-pagination-error]')?.remove();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Page unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || controller.signal.aborted) return;
        const grid = html.getElementById('product-grid');
        if (!grid) throw new Error('Product grid unavailable');
        const products = Array.from(grid.querySelectorAll(':scope > .column'));
        const handles = new Set([...this.grid.querySelectorAll('product-card[data-jb-product-id]')].map(card => card.dataset.jbProductId));
        products.forEach(product => {
          const id = product.querySelector('product-card')?.dataset.jbProductId;
          if (id && handles.has(id)) return;
          if (id) handles.add(id);
          this.grid.appendChild(product);
        });
        this.page++;
        const nextPagination = html.querySelector('pagination-theme');
        const nextLink = nextPagination?.querySelector('.load-more[href]');
        if (this.button?.matches('a') && nextLink) this.button.href = new URL(nextLink.getAttribute('href'), url).href;
        products.forEach(product => product.querySelectorAll('.lazyload').forEach(image => window.lazySizes?.loader?.unveil(image)));
        if (this.animationsEnabled && products.length) gsap.fromTo(products, { opacity: 0, y: 30 }, { duration: .5, y: 0, opacity: 1, stagger: .05 });
        window.StampedFn?.loadBadges?.();
        const collectionList = !!this.closest('jb-collection-refinements');
        if (collectionList ? !nextLink : products.length < this.pageSize || (nextPagination && !nextLink)) {
          this.done = true;
          this.hidden = true;
          this.observer?.disconnect();
        }
        dispatchCustomEvent('pagination:page-changed', { url: url.href });
      } catch (_) {
        if (this.isConnected) {
          const status = document.createElement('p');
          status.dataset.paginationError = '';
          status.setAttribute('role', 'status');
          status.textContent = 'More creations could not be loaded. Please try again.';
          this.prepend(status);
          this.classList.remove('pagination-type--infinite');
          this.classList.add('pagination-type--loadmore');
          this.observer?.disconnect();
          if (this.button) { this.button.hidden = false; this.button.style.display = ''; }
        }
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) {
          this.controller = null;
          this.removeAttribute('loading');
          this.removeAttribute('aria-busy');
          if (this.button) { this.button.disabled = false; this.button.removeAttribute('aria-disabled'); }
        }
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}

